





































































import {Base64} from 'js-base64'
import {getToken} from '@/util/common'
import {getMenus} from '@/api/menu'
import {Component, Vue, Provide, Prop} from 'vue-property-decorator'
import router from '@/router'

//引入组件
@Component({
    components: {}
})
export default class AppDrawer extends Vue {
    //data
    @Provide() logo: string = '/static/logo.png'
    @Provide() minTitle: string = "Common.SysInfo.min-title"
    @Provide() mini: boolean = false

    @Provide() menus: object = []
    @Provide() settings: object = {
        maxScrollbarLength: 160
    }

    get showDrawer() {
        return this.$store.state.showDrawer
    }

    set showDrawer(drawer: boolean) {
        this.$store.commit('setShowDrawer', drawer)
    }

    //methods
    genChildTarget(item: any, subItem: any) {
        if (subItem.menuCode) {
            return {
                name: subItem.menuCode,
            }
        }
        return {name: item.menuCode}
    }

    //computed
    computeGroupActive() {
        return true
    }

    //生命周期
    mounted() {
        const token: any = getToken()

        if (token) {
            let loginUser: any = Base64.fromBase64(token)
            loginUser = JSON.parse(loginUser)
            if (loginUser) {
                this.$store.commit('setLoginUser', loginUser)
            }
        }

        this.getMenusFromApi()
    }

    getMenusFromApi() {
        return getMenus().then((data: any) => {
            if (data) {
                this.menus = data
            } else {
                router.replace({name: 'Login'})
            }
        })
    }
}
